import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Intercept response, move data field to root response when present
        return next.handle(request).pipe(
            map(
                (event) => {
                    if (event instanceof HttpResponse && event.body) {
                        if (event.body.hasOwnProperty('results')) {
                            event = event.clone({ body: event.body.results });
                        }
                    }
                    return event;
                }
            )
        );

    }
}
